module.exports = __webpack_public_path__ + "img/tryg_white-copy.acb109cb.png";